import { Components, Theme } from '@mui/material/styles';
import { toolbarHeight } from '../variables/values';

export const muiToolbarOverride: Components<Theme>['MuiToolbar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: toolbarHeight.mobile,
      height: toolbarHeight.mobile,
      [theme.breakpoints.up('md')]: {
        minHeight: toolbarHeight.desktop,
        height: toolbarHeight.desktop,
      },
    }),
  },
};
